import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/pro-solid-svg-icons';
import { faSort as faSortDuoTone } from '@fortawesome/pro-duotone-svg-icons';

function ControlledSortHeader({
  label, isSelected, direction, onSort,
}) {
  const nextDirection = isSelected && direction === 'ASC' ? 'DES' : 'ASC';
  const handleClick = () => onSort(nextDirection);

  let icon;
  if (isSelected && direction === 'ASC') {
    icon = <FontAwesomeIcon icon={faSortDuoTone} />;
  } else if (isSelected && direction === 'DES') {
    icon = <FontAwesomeIcon icon={faSortDuoTone} style={{ transform: 'rotate(180deg)' }} />;
  } else {
    icon = <FontAwesomeIcon icon={faSort} className="text-muted" />;
  }

  return (
    <th className="text-left pl-1 pr-1">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-sm shadow-none pl-0"
          onClick={handleClick}
          aria-label={`Sort by ${label} ${nextDirection.toLowerCase()}ending`}
        >
          {icon}
        </button>
        <span
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClick();
            }
          }}
        >
          {label}
          {' '}
        </span>
      </div>
    </th>
  );
}

ControlledSortHeader.propTypes = {
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(['ASC', 'DES']),
  onSort: PropTypes.func.isRequired,
};

ControlledSortHeader.defaultProps = {
  direction: undefined,
};

export default ControlledSortHeader;
